var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashedBorder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "asset=DashedBorder, colour=NeutralDefault, htmlTag=img, assetKey=Content"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Content",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2 13.2461L3.20082 11.7461L5.54446 11.7471L5.54364 13.2471L3.2 13.2461ZM6.8569 11.7477L11.5442 11.7497L11.5434 13.2497L6.85608 13.2477L6.8569 11.7477ZM12.8566 11.7503L17.5439 11.7523L17.5431 13.2523L12.8558 13.2503L12.8566 11.7503ZM18.8564 11.7529L21.2 11.7539L21.1992 13.2539L18.8555 13.2529L18.8564 11.7529Z",
    fill: "#878D9B"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashedBorder);
export default __webpack_public_path__ + "static/media/DashedBorder.b3b877e815e2e8ff44a7a74a8d266249.svg";
export { ForwardRef as ReactComponent };